import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useControlledRef } from '../../../../internal/hooks';
export function useCheckboxGroupOptions(props) {
  var options = props.options;
  var propsRef = useValueRef(props);
  var _useControlledRef = useControlledRef({
      controlled: props.value,
      default: props.defaultValue || []
    }),
    _useControlledRef2 = _slicedToArray(_useControlledRef, 2),
    valueRef = _useControlledRef2[0],
    setValue = _useControlledRef2[1];
  return React.useMemo(function () {
    return options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        onChange: function onChange(e) {
          var optionValue = option.value;
          var onChange = propsRef.current.onChange;
          if (!onChange) {
            return;
          }
          var prevValue = valueRef.current;
          var isChecked = prevValue.includes(optionValue);
          if (isChecked) {
            setValue(prevValue.filter(function (v) {
              return v !== optionValue;
            }));
          } else {
            setValue([].concat(_toConsumableArray(prevValue), [optionValue]));
          }
          onChange(e, valueRef.current);
        }
      });
    });
  }, [options, propsRef, valueRef, setValue]);
}